const transformToSaveUserSettingsArgs = ({ userId, settings }) => ({
  userId,
  settings: {
    pageSize: Number(settings.pageSize),
  },
})

export default transformToSaveUserSettingsArgs
